module.exports = __webpack_public_path__ + "static/img/ex_img2.c31f24cb.png";